module.exports = "/images/mastercard.jpg?8d3787b2ee1593c22553740313be0547";


//////////////////
// WEBPACK FOOTER
// ./public/img/mastercard.jpg
// module id = AjYB
// module chunks = 5